import { render, staticRenderFns } from "./ChangePrices.vue?vue&type=template&id=b5305248&"
import script from "./ChangePrices.vue?vue&type=script&lang=js&"
export * from "./ChangePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5305248')) {
      api.createRecord('b5305248', component.options)
    } else {
      api.reload('b5305248', component.options)
    }
    module.hot.accept("./ChangePrices.vue?vue&type=template&id=b5305248&", function () {
      api.rerender('b5305248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ChangePrices.vue"
export default component.exports